import { render } from "./FlagLabel.vue?vue&type=template&id=40a97200&scoped=true&ts=true"
import script from "./FlagLabel.vue?vue&type=script&lang=ts"
export * from "./FlagLabel.vue?vue&type=script&lang=ts"

import "./FlagLabel.vue?vue&type=style&index=0&id=40a97200&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a97200"]])

export default __exports__